import { SignInBase } from "../../Pages/Root/sign-in-base";
import { PayPal, PayPalCaller } from "./paypal";

export class SignIn extends SignInBase {
    public static Init(): void {
        new SignIn();
    }

    constructor() {
        PayPal.Init((data, action) => this.onPayWithPayPalClicked(data, action), PayPalCaller.SignInPage);
        super("sign-in-form", "/checkout/about-you", "/ws/verify-cart-login", "/ws/set-password-checkout");
    }

    private onPayWithPayPalClicked(data, actions): Promise<any> {
        return actions.resolve();
    }
}

if (document.body.dataset.pageInit == "signin") {
    SignIn.Init();
}